<template>
  <v-dialog v-model="showDialog" :max-width="800" :persistent="loading">
    <v-card class="pa-0">
      <div class="text-right d-flex text-white bg-black pa-2">
        <div class="text-left pa-0">
          {{ title }}
        </div>
        <v-icon
          class="ml-auto"
          size="20"
          color="#fff"
          :disabled="loading"
          @click="showDialog = false"
          >mdi-close-circle</v-icon
        >
      </div>
      <v-simple-table dense class="pa-2">
        <template #default>
          <thead class="custom-table-bordered">
            <tr>
              <td class="text-center bg-gray" colspan="4">
                <b>{{ subTitle }}</b>
              </td>
            </tr>
          </thead>
          <tbody v-if="!loading" class="custom-table-bordered">
            <tr class="bg-gray">
              <td>Número de clientes con pago</td>
              <td>Clientes con pagos IEL</td>
              <td>% con pagos IEL</td>
            </tr>
            <tr>
              <td class="text-center">{{ formatFloat(data.customers, 0) }}</td>
              <td class="text-center">
                {{ formatFloat(data.customersWithIelPayment, 0) }}
              </td>
              <td class="text-center">
                {{ formatFloat(data.ielPaymentPercentage, 2) }}%
              </td>
            </tr>
          </tbody>
          <tbody v-if="loading">
            <tr>
              <td colspan="7">
                <v-progress-linear class="mt-3" indeterminate color="teal" />
                <span class="text--disabled"> Cargando información</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-btn class="ma-2" :disabled="loading" @click="showDialog = false"
        >Cerrar</v-btn
      >
    </v-card>
  </v-dialog>
</template>
<script>
  import numbersFormats from '@/mixins/numbersFormats';

  export default {
    name: 'CustomersIEL',
    mixins: [numbersFormats],
    props: {
      title: {
        type: String,
        default: 'Detalle de clientes con pago via IEL',
      },
      subTitle: {
        type: String,
        default: '% Pagos en IEL',
      },
      value: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: true,
      },
      data: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      showDialog: {
        set(value) {
          this.$emit('input', value);
        },
        get() {
          return this.value;
        },
      },
    },
  };
</script>
